import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Styled } from './ControlledRadioButtonGroup.styles';
import { RadioButton } from './RadioButton';
const ControlledRadioButtonGroup = ({ name, orientation, values, onChange, }) => {
    const [selectedValue, setSelectedValue] = useState();
    const handleChange = (value) => {
        setSelectedValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(name, value);
    };
    return (_jsx(Styled.RadioButtonContainer, { name: name, variant: orientation === 'horizontal' ? 'row' : undefined, children: values.map(({ value, label }, index) => (_jsx(RadioButton, { on: selectedValue === value, value: value, onChange: () => handleChange(value), children: label }, `${name}-radio-button-${index}`))) }));
};
export default ControlledRadioButtonGroup;
//# sourceMappingURL=ControlledRadioButtonGroup.js.map